const EditBandDetailType = {
    SET_EDIT_BAND_DETAIL:'SET_EDIT_BAND_DETAIL'
  }
  export default EditBandDetailType;